import {WBCViewActions} from '../redux_constants/wbcView.const';

export const wbcGridSelected = (value) => ({
    type : WBCViewActions.FILTER_GRID_SELECTED,
    response : value
});

export const wbcChangeImage = (value) => ({
    type : WBCViewActions.FILTER_CHANGE_IMAGE,
    resposne: value,
})

export const updatePageWBCView = (value) => ({
    type: WBCViewActions.UPDATE_PAGE,
    response: value
})

export const updatePageSizeWBC = (value) => ({
    type: WBCViewActions.UPDATE_PAGE_SIZE,
    response: value
})

export const updateAllGridsWBC = (value) => ({
    type: WBCViewActions.UPDATE_ALL_GRIDS,
    response: value,
})

export const resetZStackWBC = () => ({
    type: WBCViewActions.RESET_Z_STACK,
})

export const resetWBC = () => ({
    type: WBCViewActions.RESET,
})

export const updateWBCTag = (value) => ({
    type: WBCViewActions.CHANGE_TAG,
    response: value,
})

export const updateDifferentialConfirmStatus = (value) => ({
    type: WBCViewActions.DIFFERENTIAL_CONFIRMED,
    response: value,
})

export const updateWBCSummary = (value) => ({
    type: WBCViewActions.UPDATE_SUMMARY,
    response: value,
})

export const updateZStackWrapperWBC = (selected, zStack) => (dispatch) => {
    let image_loc = selected.image;
    let url = image_loc.split('/')
    if(zStack == 0) {
        let idx = url.indexOf('stack');
        if(idx==-1){
            return;
        }
        url[idx]='tiled'
        url.splice(idx+1,1);
    }
    else{
        let idx = url.indexOf('tiled')
        if(idx == -1){
            let idx = url.indexOf('stack');
            url[idx+1]=`S${zStack}`
        } 
        else{
            url[idx]=`stack/S${zStack}`
        }
    }
    url = url.join('/')
    let newSelected = selected;
    newSelected.image = url;
    // dispatch(updateZStackWBC(parseInt(zStack)));
    // dispatch(wbcGridSelected(newSelected));
} 
